import React from 'react'
import './Banner.css'

export const Banner = () => {
    return (
        <header className="banner" id="home">
            <div className='banner-p'>
                <p >En <strong>Legacy ITC</strong> somos un equipo de desarrolladores enfocados en la creación de soluciones tecnológicas aplicadas a la plataforma <strong>SAP</strong> que permitan mejorar los procesos del negocio.<br></br>
                    Siendo una firma boutique, hemos logrado siempre adaptarnos a las necesidades de nuestros clientes brindándoles un nivel de atención de calidad, rapido y personalizado.
                    El nivel de compromiso, atención y dedicación que proveemos a nuestros clientes nos distingue en cada emprendimiento.</p>
            </div>
        </header>
    )
}
